import placeholder from "../../assets/images/Placeholder.png"


export const imageFiles = {
    placeholder,
}
